<div class="container-fluid site-detail-general">
  <mat-tab-group (selectedTabChange)="tabChanged($event)">
    <mat-tab label="Schedules & Services">
      <div class="container-fluid schedules-services px-0">
        <div
          class="row site-info-panel my-3 no-gutters"
          *ngIf="recurringServiceSchedules$ | async as recurringServices">
          <div class="col-lg-6 col-md-12 pr-lg-2">
            <div class="schedule-info container-fluid">
              <div class="row scheduled-title">
                <div class="col-6">Last Scheduled</div>
                <div class="col-6">Next Scheduled</div>
              </div>
              <mat-divider class="my-2"></mat-divider>
              <ng-container
                *ngFor="let service of recurringServices; let isLast = last">
                <div class="row scheduled-data">
                  <div class="col-6">
                    <div>Stream: {{ service.debris }}</div>
                    <div>
                      Date:
                      {{
                        service.lastScheduled ? service.lastScheduled : 'N/A'
                      }}
                    </div>
                  </div>
                  <div class="col-6">
                    <div>Stream: {{ service.debris }}</div>
                    <div>
                      Date:
                      {{
                        service.nextScheduled ? service.nextScheduled : 'N/A'
                      }}
                    </div>
                  </div>
                  <div class="col-12" *ngIf="service.serviceDetails">
                    Service Details: {{ service.serviceDetails }}
                  </div>
                </div>
                <mat-divider class="my-2" *ngIf="!isLast"></mat-divider>
              </ng-container>
            </div>
          </div>

          <div class="col-lg-6 col-md-12 pl-lg-2 mt-3 mt-lg-0">
            <app-google-map
              *ngIf="currentSiteForMap$ | async"
              [locations$]="currentSiteForMap$"
              minHeight="14.625rem"
              mapHeight="100%">
            </app-google-map>
          </div>
        </div>

        <div class="row service-schedules mx-0 no-gutters">
          <div class="col-lg-6 col-md-12 col-sm-12 pr-lg-2">
            <div class="schedule-title">Recurring</div>
            <ng-container
              *ngIf="
                (recurringServiceSchedules$ | async).length > 0;
                else noActiveSchedules
              ">
              <app-service-schedules
                [serviceSchedules]="
                  recurringServiceSchedules$ | async
                "></app-service-schedules>
            </ng-container>
            <ng-template #noActiveSchedules>
              <app-no-data message="No active recurring services"></app-no-data>
            </ng-template>
          </div>
          <div class="col-lg-6 col-md-12 col-sm-12 pl-lg-2">
            <div class="row no-gutters">
              <div
                class="col-lg-12 col-md-12 col-sm-12"
                *appFeature="'HaulerContractDocuments'">
                <div class="schedule-title margin-space">
                  Contract Documents
                </div>
                <ng-container
                  *ngIf="
                    (onSiteHaulerContractDocuments$ | async).length > 0;
                    else noHaulerContractDocuments
                  ">
                  <app-site-hauler-contract-documents
                    [siteHaulerContractDocuments]="
                      onSiteHaulerContractDocuments$ | async
                    "></app-site-hauler-contract-documents>
                </ng-container>
                <ng-template #noHaulerContractDocuments>
                  <app-no-data
                    message="No Hauler Contract Documents Available."></app-no-data>
                </ng-template>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="schedule-title margin-space">
                  Upcoming One-Time Services
                </div>
                <ng-container
                  *ngIf="
                    (onCallServiceSchedules$ | async).length > 0;
                    else noDemandSchedules
                  ">
                  <app-service-schedules
                    [serviceSchedules]="
                      onCallServiceSchedules$ | async
                    "></app-service-schedules>
                </ng-container>
                <ng-template #noDemandSchedules>
                  <app-no-data
                    message="No On-Demand services scheduled"></app-no-data>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Site Invoices" *appFeature="'SiteInvoices'">
      <div class="my-3 site-invoices">
        <app-customer-invoices-table
          *ngIf="
            customerInvoices$ | async as customerInvoices;
            else tableLoadingVisual
          "
          [allData]="customerInvoices"
          [searchText]="searchText"
          [pageNumber]="tablePageNumber"
          [dateFilter]="selectedDate | date: 'yyyy-MM-dd\'T\'HH:mm:ss'"
          [currentSite]="currentSite$ | async">
        </app-customer-invoices-table>
        <ng-template #tableLoadingVisual>
          <app-table-loading-visual></app-table-loading-visual>
        </ng-template>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
